@if (processedWidgets().length) {
  <button
    class="widget-menu"
    type="button"
    [class.is-open]="widgetMenuIsOpen()"
    (click)="toggleWidgetMenu()"
  >
    @if (widgetMenuIsOpen()) {
      <span class="icon icon-close"></span>
    } @else {
      <span class="icon icon-widget-menu"></span>
    }
  </button>

  <div
    class="widget-menu-panel"
    [class.is-open]="widgetMenuIsOpen()"
    (click)="toggleWidgetMenu()"
  >
    <div class="widget-menu-container" (click)="stopPropagation($event)">
      @for (widget of processedWidgets(); track widget.title) {
        <div class="menu-item" (click)="handleWidgetClick(widget)">
          @if (widget.imageUrl) {
            <div class="widget-image-container">
              <img
                [src]="widget.imageUrl"
                [alt]="widget.title"
                class="widget-menu-img"
              />
            </div>
          } @else {
            <div class="icon-block-container">
              <span class="icon-block" [class]="widget.iconClass || ''"></span>
            </div>
          }

          <div class="title">{{ widget.title }}</div>
        </div>
      }
    </div>
  </div>
}
